import { render, staticRenderFns } from "./OverviewListCard.vue?vue&type=template&id=52412308&scoped=true&"
import script from "./OverviewListCard.vue?vue&type=script&lang=js&"
export * from "./OverviewListCard.vue?vue&type=script&lang=js&"
import style0 from "./OverviewListCard.vue?vue&type=style&index=0&id=52412308&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52412308",
  null
  
)

export default component.exports